import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  Box,
  Fab,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  Link,
  Popover,
  MenuItem,
  Divider,
  FormControlLabel,
  Checkbox,
  FormGroup
} from '@mui/material';
import { OpenInNew as OpenInNewIcon, Add as AddIcon, Devices as DevicesIcon } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import API_BASE_URL from '../config';
import { Snackbar, Alert } from '@mui/material';
import './Schedules.css';


const Schedules = () => {
  const [schedules, setSchedules] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const [primaryColor, setPrimaryColor] = useState(localStorage.getItem('primaryColor') || '#007bff');
  const [secondaryColor, setSecondaryColor] = useState(localStorage.getItem('secondaryColor') || '#6c757d');
  const [darkMode, setDarkMode] = useState(localStorage.getItem('darkMode') === 'true');
  const [textColor, setTextColor] = useState(darkMode ? '#ffffff' : '#000000');
  const [openDialog, setOpenDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [nameError, setNameError] = useState('');
  const [devices, setDevices] = useState([]);
  const [groups, setGroups] = useState([]);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [selectedPreset, setSelectedPreset] = useState('');
  const [selectedSchedule, setSelectedSchedule] = useState({});
  const [editedSchedule, setEditedSchedule] = useState({});
  const [selectedDateTime, setSelectedDateTime] = useState(new Date());
  const [selectedTimezone, setSelectedTimezone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone);

  const [newSchedule, setNewSchedule] = useState({
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate(),
    hour: new Date().getHours(),
    minute: new Date().getMinutes(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
  });

  const [repeat, setRepeat] = useState(false);
  const [weeklyRepeat, setWeeklyRepeat] = useState(false);
  const [monthlyRepeat, setMonthlyRepeat] = useState(false);
  const [weekDays, setWeekDays] = useState({
    monday: 0, tuesday: 0, wednesday: 0, thursday: 0,
    friday: 0, saturday: 0, sunday: 0
  });
  const [months, setMonths] = useState({
    Jan: 0, Feb: 0, Mar: 0, Apr: 0, May: 0, Jun: 0,
    Jul: 0, Aug: 0, Sep: 0, Oct: 0, Nov: 0, Dec: 0
  });

  const [presets, setPresets] = useState([]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [popoverContent, setPopoverContent] = useState([]);

  const [packageAllowance, setPackageAllowance] = useState(false);

  const timeZones = [
    { value: 'Australia/Brisbane', label: '(GMT+10:00) Brisbane' },
    { value: 'Australia/Sydney', label: '(GMT+10:00) Sydney, Melbourne' },
    { value: 'Australia/Adelaide', label: '(GMT+09:30) Adelaide' },
    { value: 'Australia/Darwin', label: '(GMT+09:30) Darwin' },
    { value: 'Australia/Perth', label: '(GMT+08:00) Perth' },
    { value: 'Australia/Eucla', label: '(GMT+08:45) Eucla' },
    { value: 'Australia/Lord_Howe', label: '(GMT+10:30) Lord Howe Island' },
    { value: 'Antarctica/Macquarie', label: '(GMT+11:00) Macquarie Island' },
    { value: 'Pacific/Auckland', label: '(GMT+12:00) Auckland, Wellington' },
    { value: 'Pacific/Chatham', label: '(GMT+12:45) Chatham Islands' },
    { value: 'Pacific/Midway', label: '(GMT-11:00) Midway Island, Samoa' },
    { value: 'America/Adak', label: '(GMT-10:00) Hawaii-Aleutian' },
    { value: 'Etc/GMT+10', label: '(GMT-10:00) Hawaii' },
    { value: 'Pacific/Marquesas', label: '(GMT-09:30) Marquesas Islands' },
    { value: 'Pacific/Gambier', label: '(GMT-09:00) Gambier Islands' },
    { value: 'America/Anchorage', label: '(GMT-09:00) Alaska' },
    { value: 'America/Los_Angeles', label: '(GMT-08:00) Pacific Time (US & Canada)' },
    { value: 'America/Denver', label: '(GMT-07:00) Mountain Time (US & Canada)' },
    { value: 'America/Chicago', label: '(GMT-06:00) Central Time (US & Canada)' },
    { value: 'America/New_York', label: '(GMT-05:00) Eastern Time (US & Canada)' },
    { value: 'America/Caracas', label: '(GMT-04:30) Caracas' },
    { value: 'America/Halifax', label: '(GMT-04:00) Atlantic Time (Canada)' },
    { value: 'America/St_Johns', label: '(GMT-03:30) Newfoundland' },
    { value: 'America/Sao_Paulo', label: '(GMT-03:00) Brasilia' },
    { value: 'America/Argentina/Buenos_Aires', label: '(GMT-03:00) Buenos Aires' },
    { value: 'America/Godthab', label: '(GMT-03:00) Greenland' },
    { value: 'Atlantic/Azores', label: '(GMT-01:00) Azores' },
    { value: 'Europe/London', label: '(GMT+00:00) London, Dublin' },
    { value: 'Europe/Paris', label: '(GMT+01:00) Paris, Amsterdam, Berlin' },
    { value: 'Europe/Athens', label: '(GMT+02:00) Athens, Istanbul' },
    { value: 'Asia/Dubai', label: '(GMT+04:00) Dubai, Abu Dhabi' },
    { value: 'Asia/Kabul', label: '(GMT+04:30) Kabul' },
    { value: 'Asia/Karachi', label: '(GMT+05:00) Karachi' },
    { value: 'Asia/Kolkata', label: '(GMT+05:30) Kolkata, Mumbai' },
    { value: 'Asia/Kathmandu', label: '(GMT+05:45) Kathmandu' },
    { value: 'Asia/Dhaka', label: '(GMT+06:00) Dhaka' },
    { value: 'Asia/Yangon', label: '(GMT+06:30) Yangon' },
    { value: 'Asia/Bangkok', label: '(GMT+07:00) Bangkok, Hanoi' },
    { value: 'Asia/Shanghai', label: '(GMT+08:00) Beijing, Shanghai' },
    { value: 'Asia/Tokyo', label: '(GMT+09:00) Tokyo, Seoul' },
    { value: 'Pacific/Noumea', label: '(GMT+11:00) Noumea' },
    { value: 'Pacific/Kiritimati', label: '(GMT+14:00) Kiritimati' },
  ];


  useEffect(() => {
    fetchPackageAllowance();
    fetchSchedules();
    fetchGroupDevices();
    fetchPresets();
  }, []);

  useEffect(() => {
      const checkLocalStorage = () => {
        const storedPrimaryColor = localStorage.getItem('primaryColor');
        const storedSecondaryColor = localStorage.getItem('secondaryColor');
        const storedDarkMode = localStorage.getItem('darkMode') === 'true';
  
        if (storedPrimaryColor !== primaryColor) {
          setPrimaryColor(storedPrimaryColor);
        }
        if (storedSecondaryColor !== secondaryColor) {
          setSecondaryColor(storedSecondaryColor);
        }
        if (storedDarkMode !== darkMode) {
          setDarkMode(storedDarkMode);
          setTextColor(storedDarkMode? '#ffffff' : '#000000');
        }
      };
  
      checkLocalStorage();
      const intervalId = setInterval(checkLocalStorage, 200);
  
      return () => clearInterval(intervalId);
    }, [primaryColor, secondaryColor, darkMode]);


  const fetchPackageAllowance = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/users/package/schedule`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.status === 401) {
        navigate('/unauthorized');
        return;
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      setPackageAllowance(data === 1);

    } catch (error) {
      console.error('Error fetching user package:', error);
      setError('Failed to fetch user package. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const fetchSchedules = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/device/schedules`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });

      if (response.status === 401) {
        navigate('/unauthorized');
        return;
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const schedulesData = await response.json();

      setSchedules(schedulesData);
      setError(null);
    } catch (error) {
      console.error('Error fetching schedules:', error);
      setError('Failed to fetch schedules. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const fetchGroupDevices = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/device/group-devices`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });

      if (response.status === 401) {
        navigate('/unauthorized');
        return;
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const groupDevices = await response.json();

      setDevices(groupDevices.devices || []);
      setGroups(groupDevices.groups || [
        { id: 0, name: 'No Group' } 
      ])
      //setSchedules(schedulesData);
    } catch (error) {
      console.error('Error fetching group devices:', error);
      setError('Failed to fetch group devices. Please try again later.');
    }
  };

  const fetchPresets = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/device/presets`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });

      if (response.status === 401) {
        navigate('/unauthorized');
        return;
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const presetsData = await response.json();
      setSelectedPreset(presetsData[0]?.id || ''); // Set default selected preset
      setPresets(presetsData);
      setError(null);
    } catch (error) {
      console.error('Error fetching presets:', error);
      setError('Failed to fetch presets. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const handleAddSchedule = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setNameError('');
  };

  const handleCloseEditDialog = () => {
    setOpenEditDialog(false);
    setNameError('');
  };

  const handleCreateSchedule = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/device/new-schedule`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ selectedDevices, newSchedule, repeat, weeklyRepeat, monthlyRepeat, weekDays, months, selectedPreset })
      });

      if (response.status === 401) {
        navigate('/unauthorized');
        return;
      }

      if (!response.ok) {
        throw new Error('Failed to create schedule');
        
      }
      
      handleSnackbarOpen('Schedule created successfully');
      handleCloseDialog();
      window.location.reload();
    } catch (error) {
      handleSnackbarOpen('Failed to create schedule', 'error');
      console.error('Error creating schedule:', error);
      // Handle error (e.g., show error message to user)
    }
  };


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleScheduleClick = (scheduleId) => {

    // reset schedulee params when opening edit dialog
    setRepeat(false);
    setWeeklyRepeat(false);
    setMonthlyRepeat(false);
    setWeekDays({
      monday: false, tuesday: false, wednesday: false, thursday: false,
      friday: false, saturday: false, sunday: false
    });
    setMonths({
      jan: false, feb: false, mar: false, apr: false, may: false, jun: false,
      jul: false, aug: false, sep: false, oct: false, nov: false, dec: false
    });

    const schedule = schedules.find(s => s.id === scheduleId);
    setEditedSchedule({
      ...schedule,
      repeatStatus: schedule.repeatStatus !== "Off"
    });
    setOpenEditDialog(true);
  };

  useEffect(() => {
    if (editedSchedule && editedSchedule.repeat_details) {
      setWeekDays({
        Monday: editedSchedule.repeat_details.monday === 1,
        Tuesday: editedSchedule.repeat_details.tuesday === 1,
        Wednesday: editedSchedule.repeat_details.wednesday === 1,
        Thursday: editedSchedule.repeat_details.thursday === 1,
        Friday: editedSchedule.repeat_details.friday === 1,
        Saturday: editedSchedule.repeat_details.saturday === 1,
        Sunday: editedSchedule.repeat_details.sunday === 1,
      });

      setMonths({
        Jan: editedSchedule.repeat_details.jan === 1,
        Feb: editedSchedule.repeat_details.feb === 1,
        Mar: editedSchedule.repeat_details.mar === 1,
        Apr: editedSchedule.repeat_details.apr === 1,
        May: editedSchedule.repeat_details.may === 1,
        Jun: editedSchedule.repeat_details.jun === 1,
        Jul: editedSchedule.repeat_details.jul === 1,
        Aug: editedSchedule.repeat_details.aug === 1,
        Sep: editedSchedule.repeat_details.sep === 1,
        Oct: editedSchedule.repeat_details.oct === 1,
        Nov: editedSchedule.repeat_details.nov === 1,
        Dec: editedSchedule.repeat_details.dec === 1,
      });
    }
  }, [editedSchedule]);

  useEffect(() => {
    if (selectedSchedule && Object.keys(selectedSchedule).length > 0) {
      setEditedSchedule(selectedSchedule);
      setSelectedDevices(selectedSchedule.devices);
      setSelectedDateTime(new Date(
        selectedSchedule.year + 2000,
        selectedSchedule.month - 1,
        selectedSchedule.day,
        selectedSchedule.hour,
        selectedSchedule.minute
      ));
      setSelectedTimezone(selectedSchedule.timezone);
      setRepeat(selectedSchedule.repeat_switch === 1);
      
      if (selectedSchedule.repeat_details) {
        setWeeklyRepeat(selectedSchedule.repeat_details.repeat_weekly === 1);
        setMonthlyRepeat(selectedSchedule.repeat_details.repeat_monthly === 1);
        setWeekDays({
          monday: selectedSchedule.repeat_details.monday === 1,
          tuesday: selectedSchedule.repeat_details.tuesday === 1,
          wednesday: selectedSchedule.repeat_details.wednesday === 1,
          thursday: selectedSchedule.repeat_details.thursday === 1,
          friday: selectedSchedule.repeat_details.friday === 1,
          saturday: selectedSchedule.repeat_details.saturday === 1,
          sunday: selectedSchedule.repeat_details.sunday === 1
        });
        setMonths({
          january: selectedSchedule.repeat_details.january === 1,
          february: selectedSchedule.repeat_details.february === 1,
          march: selectedSchedule.repeat_details.march === 1,
          april: selectedSchedule.repeat_details.april === 1,
          may: selectedSchedule.repeat_details.may === 1,
          june: selectedSchedule.repeat_details.june === 1,
          july: selectedSchedule.repeat_details.july === 1,
          august: selectedSchedule.repeat_details.august === 1,
          september: selectedSchedule.repeat_details.september === 1,
          october: selectedSchedule.repeat_details.october === 1,
          november: selectedSchedule.repeat_details.november === 1,
          december: selectedSchedule.repeat_details.december === 1
        });
      }
    }
  }, [selectedSchedule]);

  const handleSnackbarOpen = (message, severity = 'success') => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };
  
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleSave = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/device/update-schedule`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(editedSchedule)
      });

      if (response.status === 401) {
        navigate('/unauthorized');
        return;
      }

      if (!response.ok) {
        throw new Error('Failed to create schedule');
      }

      handleSnackbarOpen('Schedule updated successfully');
      handleCloseDialog();
      window.location.reload();
    } catch (error) {
      handleSnackbarOpen('Failed to update schedule', 'error');
      console.error('Error creating schedule:', error);
      // Handle error (e.g., show error message to user)
    }
  };

  const handleDelete = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/device/schedule/${editedSchedule.id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
  
      if (response.status === 401) {
        navigate('/unauthorized');
        return;
      }
  
      if (!response.ok) {
        if (response.status === 404) {
          throw new Error('Schedule not found');
        }
        throw new Error('Failed to delete schedule');
      }
  
      const data = await response.json();
      handleSnackbarOpen(data.message);
      handleCloseEditDialog();
      // Refresh the schedules list or remove the deleted schedule from the state
      setSchedules(schedules.filter(schedule => schedule.id !== editedSchedule.id));
      window.location.reload();
    } catch (error) {
      console.error('Error deleting schedule:', error);
      handleSnackbarOpen(error.message, 'error');
    }
  };

  const formatScheduledTime = (schedule) => {
    const { year, month, day, hour, minute, timezone } = schedule;
    
    // Pad month, day, hour, and minute with leading zeros if necessary
    const paddedMonth = month.toString().padStart(2, '0');
    const paddedDay = day.toString().padStart(2, '0');
    const paddedHour = hour.toString().padStart(2, '0');
    const paddedMinute = minute.toString().padStart(2, '0');

    // Determine AM or PM
    const period = hour >= 12 ? 'PM' : 'AM';
    const displayHour = hour > 12 ? hour - 12 : (hour === 0 ? 12 : hour);

    // Format timezone
    const timezoneFormatted = timezone >= 0 ? `+${timezone}` : timezone;

    return `${paddedMonth}/${paddedDay}/${year}, ${displayHour}:${paddedMinute}${period} (${timezoneFormatted})`;
  };

  const handlePresetClick = (presetId, event) => {
    event.stopPropagation();
    navigate(`/presets/${presetId}`);
  };

  const handleDevicesClick = (devices, event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setPopoverContent(devices);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleDeviceClick = (deviceId, event) => {
    event.stopPropagation();
    navigate(`/device/${deviceId}`);
  };

  if (loading) {
    return <div style={{ color: primaryColor }}>Loading schedules...</div>;
  }

  if (error) {
    return <div style={{ color: primaryColor }}>Error: {error}</div>;
  }

  const open = Boolean(anchorEl);

  return (
    <div className={`schedules ${darkMode ? 'dark-mode' : 'light-mode'}`} style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      {!packageAllowance ? (
        <div style={{ 
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: secondaryColor,
          color: textColor,
          padding: 20,
          textAlign: 'center'
        }}>
          <div>
            <Typography variant="h4" gutterBottom>
              Schedule Access Restricted
            </Typography>
            <Button 
              variant="contained" 
              onClick={() => navigate('/help')}
              sx={{ 
                mt: 2,
                backgroundColor: primaryColor,
                color: textColor,
                '&:hover': {
                  backgroundColor: darkMode ? '#555' : '#e0e0e0',
                }
              }}
            >
              Contact Support
            </Button>
          </div>
        </div>
      ) : (
        <>
        <Paper sx={{ 
          flex: 1, 
          display: 'flex', 
          flexDirection: 'column', 
          backgroundColor: secondaryColor,
          overflow: 'hidden',
        }}>
          <Box sx={{ 
            flex: 1, 
            overflow: 'auto',
            '& table': {
              borderCollapse: 'separate',
              borderSpacing: 0,
            },
          }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {['DATETIME', 'PRESET', 'DEVICES', 'REPEAT', 'ACTION'].map((header) => (
                    <TableCell 
                      key={header} 
                      sx={{ 
                        backgroundColor: `${darkMode ? '#666666' : '#aaaaaa'} !important`,
                        color: `${textColor} !important`,
                        textAlign: 'center',
                      }}
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {schedules.length > 0 ? (
                  schedules
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((schedule, index) => (
                      <TableRow 
                        key={schedule.id} 
                        hover 
                        sx={{ 
                          backgroundColor: index % 2 ? secondaryColor : (darkMode ? '#262626' : '#f5f5f5'),
                          '&:hover': {
                            backgroundColor: darkMode ? '#333333' : '#e0e0e0',
                          },
                          height: 'auto',
                        }}
                      >
                        <TableCell align="center" sx={{ color: `${textColor} !important`, padding: '8px' }}>
                          {formatScheduledTime(schedule)}
                        </TableCell>
                        <TableCell align="center" sx={{ color: `${textColor} !important`, padding: '8px' }}>
                          <Link
                            component="button"
                            variant="body2"
                            onClick={(e) => handlePresetClick(schedule.preset.id, e)}
                            sx={{ 
                              color: textColor, 
                              textDecoration: 'underline',
                              '&:hover': {
                                cursor: 'pointer',
                              },
                            }}
                          >
                            {schedule.preset.name}
                          </Link>
                        </TableCell>
                        <TableCell align="center" sx={{ color: `${textColor} !important`, padding: '8px' }}>
                          <Tooltip title="View Devices">
                            <IconButton onClick={(e) => handleDevicesClick(schedule.devices, e)} sx={{ color: textColor }}>
                              <DevicesIcon />
                              <Typography variant="body2" sx={{ ml: 1 }}>
                                {schedule.devices.length}
                              </Typography>
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                        <TableCell align="center" sx={{ color: `${textColor} !important`, padding: '8px' }}>
                          {schedule.repeatStatus}
                        </TableCell>
                        <TableCell align="center" sx={{ color: `${textColor} !important`, padding: '8px' }}>
                          <IconButton onClick={() => handleScheduleClick(schedule.id)} sx={{ color: textColor }}>
                            <OpenInNewIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell 
                      colSpan={5} 
                      align="center" 
                      sx={{ 
                        color: `${textColor} !important`, 
                        padding: '16px',
                        backgroundColor: darkMode ? '#262626' : '#f5f5f5',
                      }}
                    >
                      No schedules available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Box>
          <TablePagination
            rowsPerPageOptions={[50,100,200]}
            component="div"
            count={schedules.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              color: textColor,
              '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows, .MuiTablePagination-select, .MuiTablePagination-selectIcon': {
                color: `${textColor} !important`,
              },
              '.MuiTablePagination-actions': {
                color: textColor,
                '& .MuiIconButton-root.Mui-disabled': {
                  color: darkMode ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.5)',
                },
              },
            }}
          />
        </Paper>
      <Fab
        variant="extended"
        color="primary"
        aria-label="add schedule"
        onClick={handleAddSchedule}
        sx={{
          position: 'absolute',
          bottom: 72,
          right: 16,
          backgroundColor: primaryColor,
          color: textColor,
          '&:hover': {
            backgroundColor: darkMode ? '#555' : '#e0e0e0',
          },
        }}
        >
          <AddIcon sx={{ mr: 1 }} />
          Add Schedule
        </Fab>
        </>
      )}
        <Dialog 
          open={openDialog} 
          onClose={handleCloseDialog}
          fullWidth 
          maxWidth="md"
          PaperProps={{
            style: {
              backgroundColor: darkMode ? '#333' : '#fff',
              color: textColor,
            },
          }}
        >
        <DialogTitle sx={{ color: textColor }}>Add New Schedule</DialogTitle>
        <DialogContent>
          <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            width: '100%', 
            gap: 1, 
          }}>
            <Box sx={{ 
              display: 'flex', 
              flexDirection: 'row', 
              alignItems: 'center', 
              width: '100%', 
              gap: 2, 
            }}>
              <TextField
                type="datetime-local"
                value={`${newSchedule.year}-${String(newSchedule.month).padStart(2, '0')}-${String(newSchedule.day).padStart(2, '0')}T${String(newSchedule.hour).padStart(2, '0')}:${String(newSchedule.minute).padStart(2, '0')}`}
                onChange={(e) => {
                  const date = new Date(e.target.value);
                  setNewSchedule({
                    ...newSchedule,
                    year: date.getFullYear(),
                    month: date.getMonth() + 1,
                    day: date.getDate(),
                    hour: date.getHours(),
                    minute: date.getMinutes()
                  });
                }}
                sx={{ 
                  flex: 1, 
                  '& .MuiInputBase-root': {
                    color: `${textColor} !important`,
                    backgroundColor: `${secondaryColor} !important`,
                  },
                  '& .MuiInputBase-input': {
                    color: `${textColor} !important`,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: `${textColor} !important`,
                  },
                }}
              />
              <TextField
                select
                label="Timezone"
                value={newSchedule.timezone}
                onChange={(e) => setNewSchedule({ ...newSchedule, timezone: e.target.value })}
                sx={{ 
                  flex: 1,
                  '& .MuiInputBase-root': {
                    color: `${textColor} !important`,
                    backgroundColor: `${secondaryColor} !important`,
                  },
                  '& .MuiSelect-icon': {
                    color: `${textColor} !important`,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: `${textColor} !important`,
                  },
                  '& .MuiInputLabel-root': {
                    color: `${textColor} !important`,
                  },
                  '& .MuiSelect-select': {
                    color: `${textColor} !important`,
                  },
                }}
              >
                {timeZones.map((zone) => (
                  <MenuItem 
                    key={zone.value} 
                    value={zone.value}
                    sx={{
                      color: `${textColor} !important`,
                      backgroundColor: `${secondaryColor} !important`,
                      '&:hover': {
                        backgroundColor: `${primaryColor} !important`,
                      },
                      '&.Mui-selected': {
                        backgroundColor: `${primaryColor} !important`,
                        color: `${textColor} !important`,
                      },
                      '&.Mui-selected:hover': {
                        backgroundColor: `${primaryColor} !important`,
                        color: `${textColor} !important`,
                      },
                    }}
                  >
                    {zone.label}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
            <Divider sx={{ backgroundColor: primaryColor, my: 1 }} />
            <TextField
            select
            label="Preset"
            value={selectedPreset}
            onChange={(e) => setSelectedPreset(e.target.value)}
            sx={{ 
              flex: 1,
              '& .MuiInputBase-root': {
                color: `${textColor} !important`,
                backgroundColor: `${secondaryColor} !important`,
              },
              '& .MuiSelect-icon': {
                color: `${textColor} !important`,
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: `${textColor} !important`,
              },
              '& .MuiInputLabel-root': {
                color: `${textColor} !important`,
              },
            }}
          >
            {presets.length > 0 ? (
              presets.map((preset) => (
                <MenuItem 
                  key={preset.id} 
                  value={preset.id}
                  sx={{
                    color: `${textColor} !important`,
                    backgroundColor: `${secondaryColor} !important`,
                    '&:hover': {
                      backgroundColor: `${primaryColor} !important`,
                    },
                    '&.Mui-selected': {
                      backgroundColor: `${primaryColor} !important`,
                    },
                  }}
                >
                  {preset.preset_name}
                </MenuItem>
              ))
            ) : (
              <MenuItem 
                value=""
                disabled
                sx={{
                  color: `${textColor} !important`,
                  backgroundColor: `${secondaryColor} !important`,
                }}
              >
                Please create a preset before making a schedule
              </MenuItem>
            )}
          </TextField>

            
            <Divider sx={{ backgroundColor: primaryColor, my: 1 }} />

            <Box sx={{ 
              display: 'flex', 
              flexDirection: 'row', 
              alignItems: 'center', 
              width: '100%', 
              gap: 2, 
            }}>
              <TextField
                select
                label="Device"
                sx={{ 
                  flex: 1,
                  '& .MuiInputBase-root': {
                    color: `${textColor} !important`,
                    backgroundColor: `${secondaryColor} !important`,
                  },
                  '& .MuiSelect-icon': {
                    color: `${textColor} !important`,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: `${textColor} !important`,
                  },
                  '& .MuiInputLabel-root': {
                    color: `${textColor} !important`,
                  },
                }}
                onChange={(e) => {
                  const device = devices.find(d => d.id === e.target.value);
                  if (device && !selectedDevices.some(sd => sd.id === device.id)) {
                    setSelectedDevices([...selectedDevices, device]);
                  }
                }}
              >
                {devices.map((device) => (
                  <MenuItem 
                    key={device.id} 
                    value={device.id}
                    sx={{
                      color: `${textColor} !important`,
                      backgroundColor: `${secondaryColor} !important`,
                      '&:hover': {
                        backgroundColor: `${primaryColor} !important`,
                      },
                      '&.Mui-selected': {
                        backgroundColor: `${primaryColor} !important`,
                      },
                    }}
                  >
                    {device.device_name}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                select
                label="Group"
                sx={{ 
                  flex: 1,
                  '& .MuiInputBase-root': {
                    color: `${textColor} !important`,
                    backgroundColor: `${secondaryColor} !important`,
                  },
                  '& .MuiSelect-icon': {
                    color: `${textColor} !important`,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: `${textColor} !important`,
                  },
                  '& .MuiInputLabel-root': {
                    color: `${textColor} !important`,
                  },
                }}
                onChange={(e) => {
                  const group = groups.find(g => g.id === e.target.value);
                  if (group) {
                    const newDevices = group.devices.filter(
                      device => !selectedDevices.some(sd => sd.id === device.id)
                    );
                    setSelectedDevices([...selectedDevices, ...newDevices]);
                  }
                }}
              >
                {groups.map((group) => (
                  <MenuItem 
                    key={group.id} 
                    value={group.id}
                    sx={{
                      color: `${textColor} !important`,
                      backgroundColor: `${secondaryColor} !important`,
                      '&:hover': {
                        backgroundColor: `${primaryColor} !important`,
                      },
                      '&.Mui-selected': {
                        backgroundColor: `${primaryColor} !important`,
                      },
                    }}
                  >
                    {`${group.group_name} - ${group.devices.length} devices`}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell 
                      sx={{ 
                        backgroundColor: `${darkMode ? '#666666' : '#aaaaaa'} !important`,
                        color: `${textColor} !important`
                      }}
                    >
                      Device Name
                    </TableCell>
                    <TableCell 
                      align="right" 
                      sx={{ 
                        backgroundColor: `${darkMode ? '#666666' : '#aaaaaa'} !important`,
                        color: `${textColor} !important`
                      }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {selectedDevices.length > 0 ? (
                    selectedDevices.map((device, index) => (
                      <TableRow 
                        key={device.id}
                        sx={{ 
                          backgroundColor: index % 2 ? secondaryColor : (darkMode ? '#262626' : '#f5f5f5'),
                          '&:hover': {
                            backgroundColor: darkMode ? '#333333' : '#e0e0e0',
                          },
                        }}
                      >
                        <TableCell sx={{ color: `${textColor} !important` }}>{device.device_name}</TableCell>
                        <TableCell align="right">
                          <IconButton 
                            onClick={() => setSelectedDevices(selectedDevices.filter(d => d.id !== device.id))}
                            sx={{ color: textColor }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell 
                        colSpan={2} 
                        align="center" 
                        sx={{ 
                          color: textColor,
                          padding: '16px',
                          backgroundColor: darkMode ? '#262626' : '#f5f5f5',
                        }}
                      >
                        Please select a device or group
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
          </Box>
          <Divider sx={{ backgroundColor: primaryColor, my: 1 }} />

          <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            width: '100%', 
            gap: 2,
            flexShrink: 0,
            mt: 1
          }}>
            <FormControlLabel
              control={
                <Checkbox 
                  checked={repeat} 
                  onChange={(e) => setRepeat(e.target.checked)}
                  sx={{ color: textColor }}
                />
              }
              label="Repeat"
              sx={{ color: textColor }}
            />

            <Box sx={{ display: 'flex', flexDirection: 'column', ml: 4 }}>
              <FormControlLabel
                control={
                  <Checkbox 
                    checked={weeklyRepeat} 
                    onChange={(e) => setWeeklyRepeat(e.target.checked)}
                    disabled={!repeat}
                    sx={{ color: textColor }}
                  />
                }
                label="Weekly"
                sx={{ color: textColor }}
              />
              <FormGroup row sx={{ ml: 4 }}>
                {Object.entries(weekDays).map(([day, checked]) => (
                  <FormControlLabel
                    key={day}
                    control={
                      <Checkbox 
                        checked={checked} 
                        onChange={(e) => setWeekDays({...weekDays, [day]: e.target.checked})}
                        disabled={!repeat || !weeklyRepeat}
                        sx={{ color: textColor }}
                      />
                    }
                    label={day.charAt(0).toUpperCase() + day.slice(1)}
                    sx={{ color: textColor }}
                  />
                ))}
              </FormGroup>

              <FormControlLabel
                control={
                  <Checkbox 
                    checked={monthlyRepeat} 
                    onChange={(e) => setMonthlyRepeat(e.target.checked)}
                    disabled={!repeat}
                    sx={{ color: textColor }}
                  />
                }
                label="Monthly"
                sx={{ color: textColor }}
              />
              <FormGroup row sx={{ ml: 4 }}>
                {Object.entries(months).map(([month, checked]) => (
                  <FormControlLabel
                    key={month}
                    control={
                      <Checkbox 
                        checked={checked} 
                        onChange={(e) => setMonths({...months, [month]: e.target.checked})}
                        disabled={!repeat || !monthlyRepeat}
                        sx={{ color: textColor }}
                      />
                    }
                    label={month.toUpperCase()}
                    sx={{ color: textColor }}
                  />
                ))}
              </FormGroup>
            </Box>
          </Box>
        </DialogContent>
        
        <DialogActions>
          <Button 
            onClick={handleCreateSchedule} 
            sx={{
              color: (darkMode ? '#4caf50' : '#45a049'),
              backgroundColor:(darkMode ? 'rgba(76, 175, 80, 0.1)' : 'rgba(76, 175, 80, 0.1)'), 
              '&:hover': {
                backgroundColor: (darkMode ? 'rgba(76, 175, 80, 0.2)' : 'rgba(76, 175, 80, 0.2)'),
              },
            }}
            disabled={
              newSchedule.year == null || 
              newSchedule.month == null || 
              newSchedule.day == null || 
              newSchedule.hour == null || 
              newSchedule.minute == null || 
              selectedDevices.length === 0 || 
              !selectedPreset
            }
          >
            Create
          </Button>
          <Button onClick={handleCloseDialog} sx={{ color: textColor }}>Cancel</Button>
        </DialogActions>
      </Dialog>
      <Dialog 
        open={openEditDialog} 
        onClose={handleCloseEditDialog}
        fullWidth 
        maxWidth="md"
        PaperProps={{
          style: {
            backgroundColor: darkMode ? '#333' : '#fff',
            color: textColor,
          },
        }}
      >
        <DialogTitle sx={{ color: textColor }}>Edit Schedule</DialogTitle>
        <DialogContent>
          <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            width: '100%', 
            gap: 1, 
          }}>
            <Box sx={{ 
              display: 'flex', 
              flexDirection: 'row', 
              alignItems: 'center', 
              width: '100%', 
              gap: 2, 
            }}>
              <TextField
                type="datetime-local"
                value={`20${editedSchedule.year}-${String(editedSchedule.month).padStart(2, '0')}-${String(editedSchedule.day).padStart(2, '0')}T${String(editedSchedule.hour).padStart(2, '0')}:${String(editedSchedule.minute).padStart(2, '0')}`}
                onChange={(e) => {
                  const date = new Date(e.target.value);
                  setEditedSchedule({
                    ...editedSchedule,
                    year: date.getFullYear() - 2000,
                    month: date.getMonth() + 1,
                    day: date.getDate(),
                    hour: date.getHours(),
                    minute: date.getMinutes()
                  });
                }}
                sx={{ 
                  flex: 1, 
                  '& .MuiInputBase-root': {
                    color: `${textColor} !important`,
                    backgroundColor: `${secondaryColor} !important`,
                  },
                  '& .MuiInputBase-input': {
                    color: `${textColor} !important`,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: `${textColor} !important`,
                  },
                }}
              />
              <TextField
                select
                label="Timezone"
                value={editedSchedule.timezone}
                onChange={(e) => setEditedSchedule({ ...editedSchedule, timezone: e.target.value })}
                sx={{ 
                  flex: 1,
                  '& .MuiInputBase-root': {
                    color: `${textColor} !important`,
                    backgroundColor: `${secondaryColor} !important`,
                  },
                  '& .MuiSelect-icon': {
                    color: `${textColor} !important`,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: `${textColor} !important`,
                  },
                  '& .MuiInputLabel-root': {
                    color: `${textColor} !important`,
                  },
                  '& .MuiSelect-select': {
                    color: `${textColor} !important`,
                  },
                }}
              >
                {timeZones.map((zone) => (
                  <MenuItem 
                    key={zone.value} 
                    value={zone.value}
                    sx={{
                      color: `${textColor} !important`,
                      backgroundColor: `${secondaryColor} !important`,
                      '&:hover': {
                        backgroundColor: `${primaryColor} !important`,
                      },
                      '&.Mui-selected': {
                        backgroundColor: `${primaryColor} !important`,
                        color: `${textColor} !important`,
                      },
                      '&.Mui-selected:hover': {
                        backgroundColor: `${primaryColor} !important`,
                        color: `${textColor} !important`,
                      },
                    }}
                  >
                    {zone.label}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
            <Divider sx={{ backgroundColor: primaryColor, my: 1 }} />
            <TextField
            select
            label="Preset"
            value={editedSchedule.preset?.id}
            onChange={(e) => {
              const selectedPresetId = e.target.value;
              const selectedPreset = presets.find(p => p.id === selectedPresetId);
              setEditedSchedule({ 
                ...editedSchedule, 
                preset: { 
                  id: selectedPreset.id,
                  name: selectedPreset.preset_name
                } 
              });
            }}
            sx={{ 
              flex: 1,
              '& .MuiInputBase-root': {
                color: `${textColor} !important`,
                backgroundColor: `${secondaryColor} !important`,
              },
              '& .MuiSelect-icon': {
                color: `${textColor} !important`,
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: `${textColor} !important`,
              },
              '& .MuiInputLabel-root': {
                color: `${textColor} !important`,
              },
            }}
          >
            {presets.length > 0 ? (
              presets.map((preset) => (
                <MenuItem 
                  key={preset.id} 
                  value={preset.id}
                  sx={{
                    color: `${textColor} !important`,
                    backgroundColor: `${secondaryColor} !important`,
                    '&:hover': {
                      backgroundColor: `${primaryColor} !important`,
                    },
                    '&.Mui-selected': {
                      backgroundColor: `${primaryColor} !important`,
                    },
                  }}
                >
                  {preset.preset_name}
                </MenuItem>
              ))
            ) : (
              <MenuItem
                value=""
                disabled
                sx={{
                  color: `${textColor} !important`,
                  backgroundColor: `${secondaryColor} !important`,
                }}
              >
                Please create a preset before making a schedule
              </MenuItem>
            )}
          </TextField>
   
            <Divider sx={{ backgroundColor: primaryColor, my: 1 }} />
            <Box sx={{ 
              display: 'flex', 
              flexDirection: 'row', 
              alignItems: 'center', 
              width: '100%', 
              gap: 2, 
            }}>
              <TextField
                select
                label="Device"
                sx={{ 
                  flex: 1,
                  '& .MuiInputBase-root': {
                    color: `${textColor} !important`,
                    backgroundColor: `${secondaryColor} !important`,
                  },
                  '& .MuiSelect-icon': {
                    color: `${textColor} !important`,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: `${textColor} !important`,
                  },
                  '& .MuiInputLabel-root': {
                    color: `${textColor} !important`,
                  },
                }}
                onChange={(e) => {
                  const device = devices.find(d => d.id === e.target.value);
                  if (device && !selectedDevices.some(sd => sd.id === device.id)) {
                    setEditedSchedule(prevState => ({
                      ...prevState,
                      devices: [
                        ...prevState.devices,
                        {
                          id: device.id,
                          name: device.device_name
                        }
                      ]
                    }));
                  }
                }}
              >
                {devices.map((device) => (
                  <MenuItem 
                    key={device.id} 
                    value={device.id}
                    sx={{
                      color: `${textColor} !important`,
                      backgroundColor: `${secondaryColor} !important`,
                      '&:hover': {
                        backgroundColor: `${primaryColor} !important`,
                      },
                      '&.Mui-selected': {
                        backgroundColor: `${primaryColor} !important`,
                      },
                    }}
                  >
                    {device.device_name}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                select
                label="Group"
                sx={{ 
                  flex: 1,
                  '& .MuiInputBase-root': {
                    color: `${textColor} !important`,
                    backgroundColor: `${secondaryColor} !important`,
                  },
                  '& .MuiSelect-icon': {
                    color: `${textColor} !important`,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: `${textColor} !important`,
                  },
                  '& .MuiInputLabel-root': {
                    color: `${textColor} !important`,
                  },
                }}
                onChange={(e) => {
                  const group = groups.find(g => g.id === e.target.value);
                  if (group) {
                    const newDevices = group.devices.filter(
                      device => !selectedDevices.some(sd => sd.id === device.id)
                    );
                    setEditedSchedule(prevState => {
                      const newDevices = group.devices.filter(
                        device => !prevState.devices.some(d => d.id === device.id)
                      ).map(device => ({
                        id: device.id,
                        name: device.device_name
                      }));
              
                      return {
                        ...prevState,
                        devices: [
                          ...prevState.devices,
                          ...newDevices
                        ]
                      };
                    });
                    
                  }
                }}
              >
                {groups.map((group) => (
                  <MenuItem 
                    key={group.id} 
                    value={group.id}
                    sx={{
                      color: `${textColor} !important`,
                      backgroundColor: `${secondaryColor} !important`,
                      '&:hover': {
                        backgroundColor: `${primaryColor} !important`,
                      },
                      '&.Mui-selected': {
                        backgroundColor: `${primaryColor} !important`,
                      },
                    }}
                  >
                    {`${group.group_name} - ${group.devices.length} devices`}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell 
                      sx={{ 
                        backgroundColor: `${darkMode ? '#666666' : '#aaaaaa'} !important`,
                        color: `${textColor} !important`
                      }}
                    >
                      Device Name
                    </TableCell>
                    <TableCell 
                      align="right" 
                      sx={{ 
                        backgroundColor: `${darkMode ? '#666666' : '#aaaaaa'} !important`,
                        color: `${textColor} !important`
                      }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {editedSchedule?.devices?.length > 0 ? (
                    editedSchedule.devices.map((device, index) => (
                      <TableRow 
                        key={device.id}
                        sx={{ 
                          backgroundColor: index % 2 ? secondaryColor : (darkMode ? '#262626' : '#f5f5f5'),
                          '&:hover': {
                            backgroundColor: darkMode ? '#333333' : '#e0e0e0',
                          },
                        }}
                      >
                        <TableCell sx={{ color: `${textColor} !important` }}>{device.name}</TableCell>
                        <TableCell align="right">
                          <IconButton // setSelectedDevices(selectedDevices.filter(d => d.id !== device.id))
                            onClick={() => setEditedSchedule(prevState => ({
                              ...prevState,
                              devices: editedSchedule.devices.filter(d => d.id !== device.id)
                            }))}
                            
                            sx={{ color: textColor }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell 
                        colSpan={2} 
                        align="center" 
                        sx={{ 
                          color: textColor,
                          padding: '16px',
                          backgroundColor: darkMode ? '#262626' : '#f5f5f5',
                        }}
                      >
                        Please select a device or group
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
          </Box>
          <Divider sx={{ backgroundColor: primaryColor, my: 1 }} />
          <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            width: '100%', 
            gap: 2,
            flexShrink: 0,
            mt: 1
          }}>
            <FormControlLabel
              control={
                <Checkbox 
                  checked={ editedSchedule.repeatStatus || false } 
                  onChange={(e) => setEditedSchedule({ ...editedSchedule, repeatStatus: e.target.checked })}
                  sx={{ color: textColor }}
                />
              }
              label="Repeat"
              sx={{ color: textColor }}
            />

            <Box sx={{ display: 'flex', flexDirection: 'column', ml: 4 }}>
              <FormControlLabel
                control={
                  <Checkbox 
                    checked={editedSchedule.repeat_details?.repeat_weekly === 1 || false} 
                    onChange={(e) => setEditedSchedule(prevState => ({
                      ...prevState,
                      repeat_details: {
                        ...prevState.repeat_details,
                        repeat_weekly: e.target.checked ? 1 : 0
                      }
                    }))}
                    disabled={!editedSchedule.repeatStatus}
                    sx={{ color: textColor }}
                  />
                }
                label="Weekly"
                sx={{ color: textColor }}
              />
              <FormGroup row sx={{ ml: 4 }}>
                {Object.entries(weekDays).map(([day, checked]) => (
                  <FormControlLabel
                    key={day}
                    control={
                      <Checkbox 
                        checked={checked} 
                        onChange={(e) => {
                          const newCheckedValue = e.target.checked ? 1 : 0;
                          setWeekDays({...weekDays, [day]: newCheckedValue });
                          setEditedSchedule(prevState => ({
                            ...prevState,
                            repeat_details: {
                              ...prevState.repeat_details,
                              [day.toLowerCase()]: newCheckedValue
                            }
                          }));
                        }}
                        disabled={!editedSchedule.repeatStatus || editedSchedule.repeat_details?.repeat_weekly !== 1}
                        sx={{ color: textColor }}
                      />
                    }
                    label={day.charAt(0).toUpperCase() + day.slice(1)}
                    sx={{ color: textColor }}
                  />
                ))}
              </FormGroup>
              <FormControlLabel
                control={
                  <Checkbox 
                    checked={ editedSchedule.repeat_details?.repeat_monthly || false } 
                    onChange={(e) => setEditedSchedule(prevState => ({
                      ...prevState,
                      repeat_details: {
                        ...prevState.repeat_details,
                        repeat_monthly: e.target.checked ? 1 : 0
                      }
                    }))}
                    disabled={!editedSchedule.repeatStatus}
                    sx={{ color: textColor }}
                  />
                }
                label="Monthly"
                sx={{ color: textColor }}
              />
              <FormGroup row sx={{ ml: 4 }}>
                {Object.entries(months).map(([month, checked]) => (
                  <FormControlLabel
                    key={month}
                    control={
                      <Checkbox 
                        checked={checked} 
                        onChange={(e) => {
                          const newCheckedValue = e.target.checked;
                          setMonths(prev => ({...prev, [month]: newCheckedValue }));
                          setEditedSchedule(prevState => ({
                            ...prevState,
                            repeat_details: {
                              ...prevState.repeat_details,
                              [month.toLowerCase()]: newCheckedValue ? 1 : 0
                            }
                          }));
                        }}
                        disabled={!editedSchedule.repeatStatus || editedSchedule.repeat_details?.repeat_monthly !== 1}
                        sx={{ color: textColor }}
                      />
                    }
                    label={month}
                    sx={{ color: textColor }}
                  />
                ))}
              </FormGroup>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={handleSave} 
            sx={{
              color: (darkMode ? '#4caf50' : '#45a049'),
              backgroundColor:(darkMode ? 'rgba(76, 175, 80, 0.1)' : 'rgba(76, 175, 80, 0.1)'), 
              '&:hover': {
                backgroundColor: (darkMode ? 'rgba(76, 175, 80, 0.2)' : 'rgba(76, 175, 80, 0.2)'),
              },
            }}
            disabled={!editedSchedule}
          >
            Update
          </Button>
          <Button 
            onClick={handleDelete} 
            sx={{
              color: (darkMode ? '#f44336' : '#d32f2f'),
              backgroundColor: (darkMode ? 'rgba(244, 67, 54, 0.1)' : 'rgba(244, 67, 54, 0.1)'), 
              '&:hover': {
                backgroundColor: (darkMode ? 'rgba(244, 67, 54, 0.2)' : 'rgba(244, 67, 54, 0.2)'),
              },
            }}
          >
            Delete
          </Button>
          <Button onClick={handleCloseEditDialog} sx={{ color: textColor }}>Cancel</Button>
        </DialogActions>
      </Dialog>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Typography sx={{ p: 2, backgroundColor: `${primaryColor}` }}>Devices:</Typography>
        {popoverContent.map((device) => (
          <Typography key={device.id} sx={{ p: 1, backgroundColor: `${secondaryColor}` }}>
            <Link
              component="button"
              variant="body2"
              onClick={(e) => handleDeviceClick(device.id, e)}
              sx={{ 
                color: textColor, 
                textDecoration: 'underline',
                '&:hover': {
                  cursor: 'pointer',
                },
              }}
            >
              {device.name}
            </Link>
          </Typography>
        ))}
      </Popover>
      <Snackbar 
        open={snackbarOpen} 
        autoHideDuration={6000} 
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert 
          onClose={handleSnackbarClose} 
          severity={snackbarSeverity} 
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Schedules;